import { groupBy } from "lodash";

export const multipleSubscriptionPlans = (plans) => {
  const groups = groupBy(plans, 'category');
  return Object.keys(groups).map(category => ({
    category,
    plans: groups[category],
  })).filter(group => {
    return group.plans?.length > 1;
  });
};

export const hasMultipleSubscriptionPlan = (plans) => {
  return multipleSubscriptionPlans(plans).length > 0;
};
